module.exports = __webpack_public_path__ + "img/line.6a5ee0b6.jpg";